import React from 'react';
import css from './SignupForm.module.css';
import { FieldPhoneNumberInput, FieldTextInput } from '../../../components';
import { composeValidators, required } from '../../../util/validators';
import classNames from 'classnames';
const SchoolInputFormFields = ({
  isEditListingDetailsForm,
  intl,
  formId,
  values,
  emailFormatValid,
  emailRequired,
  handleBioChange,
  remainingChars,
  bio,
}) => {
  return (
    <>
      <div className={css.formRow}>
        <FieldTextInput
          className={css.formFld}
          type="email"
          id={formId ? `${formId}.email` : 'email'}
          name="email"
          autoComplete="email"
          label={intl.formatMessage({
            id: 'SchoolInputFormFields.contactEmailLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'SchoolInputFormFields.contactEmailPlaceholder',
          })}
          validate={composeValidators(emailRequired, emailFormatValid)}
          disabled={isEditListingDetailsForm}
        />
        <FieldPhoneNumberInput
          className={css.formFld}
          type="text"
          id={formId ? `${formId}.phoneNumber` : 'phoneNumber'}
          name="phoneNumber"
          label={intl.formatMessage({
            id: `SchoolInputFormFields.contactPhoneNumberLabel`,
          })}
          placeholder={intl.formatMessage({
            id: `SchoolInputFormFields.contactPhoneNumberPlaceholder`,
          })}
          validate={required(
            intl.formatMessage({
              id: 'SchoolInputFormFields.contactPhoneNumberRequired',
            })
          )}
        />
      </div>
      <div className={css.formRow}>
        <FieldTextInput
          className={css.formFld}
          type="text"
          id={formId ? `${formId}.firstName` : 'firstName'}
          name="firstName"
          autoComplete="given-name"
          label={intl.formatMessage({
            id: 'SchoolInputFormFields.contactFirstNameLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'SchoolInputFormFields.contactFirstNamePlaceholder',
          })}
          validate={required(
            intl.formatMessage({
              id: 'SchoolInputFormFields.contactFirstNameRequired',
            })
          )}
        />

        <FieldTextInput
          className={css.formFld}
          type="text"
          id={formId ? `${formId}.lastName` : 'lastName'}
          name="lastName"
          autoComplete="family-name"
          label={intl.formatMessage({
            id: 'SchoolInputFormFields.contactLastNameLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'SchoolInputFormFields.contactLastNamePlaceholder',
          })}
          validate={required(
            intl.formatMessage({
              id: 'SchoolInputFormFields.contactLastNameRequired',
            })
          )}
        />
      </div>

      <div className={classNames(css.formRow, css.fullWidth)}>
        <FieldTextInput
          className={css.formFld}
          type="text"
          id={formId ? `${formId}.contactTitle` : 'contactTitle'}
          name="contactTitle"
          autoComplete="family-name"
          label={intl.formatMessage({
            id: 'SchoolInputFormFields.contactTitleLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'SchoolInputFormFields.contactTitlePlaceholder',
          })}
          validate={required(
            intl.formatMessage({
              id: 'SchoolInputFormFields.contactTitleRequired',
            })
          )}
        />
      </div>
      <div className={classNames(css.formRow, css.fullWidth)}>
        <FieldTextInput
          id={`${formId}description`}
          name="description"
          className={css.description}
          type="textarea"
          label={intl.formatMessage({ id: 'SchoolInputFormFields.description' })}
          placeholder={intl.formatMessage({
            id: 'SchoolInputFormFields.descriptionPlaceholder',
          })}
          validate={required(
            intl.formatMessage({
              id: 'SchoolInputFormFields.descriptionRequired',
            })
          )}
          value={bio}
          onChange={handleBioChange}
        />
        <div
          className={classNames(css.characterCount, {
            [css.warning]: remainingChars < 10 && remainingChars > 0,
            [css.limitReached]: remainingChars === 0,
          })}
        >
          {remainingChars}{' '}
          {intl.formatMessage({
            id: 'SignupForm.descriptionCharactersLeft',
          })}
        </div>
      </div>
    </>
  );
};

export default SchoolInputFormFields;
